import { useState, useEffect } from "react";
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck, faMountainSun } from '@fortawesome/free-solid-svg-icons';

const InviteCard = ({ inviteGroupKey, inviteKeyList }) => {
    const [inviteCopied, setInviteCopied] = useState({});

    useEffect(() => {
        if (inviteKeyList) {
            const initialCopied = {};
            inviteKeyList.forEach((_, i) => {
                initialCopied[i] = false;
            });
            setInviteCopied(initialCopied);
        }
    }, [inviteKeyList]);

async function copyCard(groupKey, inviteKey, index) {
    const text = `Join my SH Quiz Game group at:\nhttps://www.sugarloafhomestead.com/quizgame\nGroup Key: ${groupKey}\nInvite Key: ${inviteKey}`;

    navigator.clipboard.writeText(text)
      .then(() => setInviteCopied({ ...inviteCopied, [index]: true }))
      .catch((err) => alert('Failed to copy: ' + err));
}


    return (
        inviteKeyList.map((key, index) => (
        <div key={key} className="d-flex flex-column justify-content-center">
        {!inviteCopied[index] ? (
            <p className="my-1">
                <FontAwesomeIcon icon={faCopy} className="me-1" /> 
                Click to copy
            </p>
            ) : (
            <p className="my-1">
                <FontAwesomeIcon icon={faCheck} className="me-1 copy" /> 
                Copied!
            </p>
            )
        }
        
        <Card 
        className="mb-4 shadow-sm border-0"
        id={`invite-card-${key}`} 
        onClick={() => copyCard(inviteGroupKey, key, index)}>
            <Card.Header className="card-header container">
                <span className="logo"><FontAwesomeIcon icon={faMountainSun} className="me-2" />Sugarloaf</span>Homestead
            </Card.Header>
            <Card.Title className="invite-title">
                Join my Quiz Game group:
            </Card.Title>
            <Card.Body className="bg-light py-2">
                <Card.Text className="mb-2">
                <strong>group_key:</strong> {inviteGroupKey}
                </Card.Text>
                <Card.Text>
                <strong>invite_key:</strong> {key}
                </Card.Text>
            </Card.Body>
        </Card>
        </div>
        ))
    );
}

export default InviteCard